import { LanguageOutputWithoutStatus } from './language-output-without-status.model';


export class LanguageSelectActiveOutput implements ILanguageSelectActiveOutput {
    status!: number;
    message!: string;
    data!: LanguageOutputWithoutStatus[];

    constructor(data?: ILanguageSelectActiveOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LanguageOutputWithoutStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LanguageSelectActiveOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageSelectActiveOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ILanguageSelectActiveOutput {
    status: number;
    message: string;
    data: LanguageOutputWithoutStatus[];
}

